type PasswordLength = 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15;

function randomChar(chars: string): string {
  return chars[Math.floor(Math.random() * chars.length)];
}

export function generateComplexPassword(length: PasswordLength): string {
  const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
  const numberChars = '0123456789';
  const specialChars = '@$!%+.*_?&#-';

  const allChars = uppercaseChars + lowercaseChars + numberChars + specialChars;
  let password = '';
  // Ensure at least one of each required type
  password += randomChar(uppercaseChars);
  password += randomChar(lowercaseChars);
  password += randomChar(numberChars);
  password += randomChar(specialChars);

  // Fill the rest
  for (let i = password.length; i < length; i++) {
    password += randomChar(allChars);
  }

  // Shuffle result so guaranteed chars aren’t always at the front
  return password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('');
}

